// Billing Subscription Portal
export const BILLING_SUBSCRIPTION_PORTAL_REQUEST = 'BILLING_SUBSCRIPTION_PORTAL_REQUEST';
export const BILLING_SUBSCRIPTION_PORTAL_DONE = 'BILLING_SUBSCRIPTION_PORTAL_DONE';
export const BILLING_SUBSCRIPTION_PORTAL_FAILED = 'BILLING_SUBSCRIPTION_PORTAL_FAILED';
export const BILLING_SUBSCRIPTION_PORTAL_RESET = 'BILLING_SUBSCRIPTION_PORTAL_RESET';